import fetch from 'services/request';
import { GetStaffListParams, CreateOrUpdateStaffBody } from './constants';

const API_V1 = '/api/v1';
const STAFF_BASE_URL = API_V1 + '/staff';

const api = {
  staff: {
    getList: (params: GetStaffListParams) =>
      fetch({
        method: 'get',
        url: `${STAFF_BASE_URL}/all`,
        params: {
          staffType: params.staffType || '',
          keySearch: params.keySearch || '',
          status: params.status || '',
        },
      }),

    getDetail: (staffId: string) =>
      fetch({
        method: 'get',
        url: `${STAFF_BASE_URL}/detail/${staffId}`,
      }),

    create: (data: CreateOrUpdateStaffBody) =>
      fetch({
        method: 'post',
        url: STAFF_BASE_URL,
        body: data,
      }),

    update: (data: CreateOrUpdateStaffBody) =>
      fetch({
        method: 'put',
        url: STAFF_BASE_URL,
        body: data,
      }),

    delete: (staffId: string) =>
      fetch({
        method: 'delete',
        url: `${STAFF_BASE_URL}/delete/${staffId}`,
      }),
  },
};

export default api;
